<div class="side-bar" id="trip-replay-side-bar">
  <div class="top" *ngIf="tripDetails">
    <button class="back_btn" (click)="goToTripView()">
      <img [src]="replayImgSrc + 'assets/icons/left-arrow.svg'" alt="backbtn" />
    </button>
    <div class="tripid">{{tripDetails['tripId']}}</div>
    <div class="in_box">{{tripDetails['direction']}}</div>
    <div class="trip_type">
      {{tripDetails['tripType']!=='Adhoc'? 'PLANNED': 'ADHOC'}}
      <img class="adhoc-icon" *ngIf="tripDetails['tripType']==='Adhoc'" (mouseenter)="adhocTooltipVisible = true" [src]="INFO_ICON" alt="">
    </div>

    <div class="custom-tooltip" *ngIf="adhocTooltipVisible && tripDetails['tripType']==='Adhoc'">
      <div class="tooltip-heading">AdHoc Trip</div>
      <img class="tooltip-close" [src]="ASSETS_PATH_CONST.CANCEL_ICON" (click)="toolTipClose()" />
      <div class="tooltip-content">{{adhoc_text}}</div>
    </div>

    <button class="duty_view" *ngIf="false">
      Duty View
      <img [src]="replayImgSrc + 'assets/icons/duty-view.svg'" alt="duty-view-arrow" />
    </button>
  </div>

  <!-- Tabs -->
  <div class="side-bar-tabs">
    <div class="tab" (click)="setActiveTab('trip')" [ngClass]="{'active': activeTab==='trip' }">Trip</div>
    <div class="tab" (click)="setActiveTab('events')" [ngClass]="{'active': activeTab==='events'}">Events</div>
  </div>
  <!-- Tab Window -->
  <app-trip-tab *ngIf="activeTab==='trip'" [isCabView]="isCabView"></app-trip-tab>
  <app-event-tab *ngIf="activeTab==='events'"></app-event-tab>
</div>